import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
//visitor
import Home from "./containers/visitor/home";
import Contact from "./containers/visitor/contact";
import About from "./containers/visitor/about";
import Login from "./containers/visitor/login";
import SignUp from "./containers/visitor/sign-up";
import ScrollToTop from "./utils/ScrollToTop";
import Policies from "./containers/visitor/policies";
import Redirectt from "./containers/visitor/redirect";
import ResetPassword from "./containers/visitor/reset-password";
import NewPassword from "./containers/visitor/reset-password/new-password";
//user
import Dashboard from "./containers/user/dashboard";
import ClientSettings from "./containers/user/setting";
import NewLink from "./containers/user/new-link";
import ClientLinks from "./containers/user/links";
import ClientQRCodes from "./containers/user/qr-code";
//
import Layout from "./utils/Layout";
import LoggedInLayout from "./utils/LoggedInLayout";
import LoggedOutLayout from "./utils/LoggedOutLayout";
import RequireAuth from "./utils/RequireAuth";
import PersistLogin from "./utils/PersistLogin";
import Loader from "./utils/Loader";
import ThemeManager from "./utils/ThemeManager";

const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};
function App() {
  useEffect(() => {
    ThemeManager.initializeTheme();
  }, []);
  return (
    <>
      <ScrollToTop />
      <Routes basename="/">
        <Route path="/" element={<Layout />}>
          <Route path="/:linkId" element={<Redirectt />} />
          <Route element={<PersistLogin />}>
            <Route path="/" element={<LoggedOutLayout />}>
              <Route path="" element={<Home />} />
              <Route path="l" element={<Loader />} />
              <Route path="home" element={<Home />} />
              <Route path="login" element={<Login />} />
              <Route path="reset" element={<ResetPassword />} />
              <Route path="signup" element={<SignUp />} />
              <Route path="policies" element={<Policies />} />
              <Route path="about" element={<About />} />
              <Route path="/:linkId" element={<Redirectt />} />
              <Route path="contact" element={<Contact />} />
            </Route>
            <Route element={<RequireAuth allowedRoles={[ROLES.User]} />}>
              <Route path="/" element={<LoggedInLayout />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/links" element={<ClientLinks />} />
                <Route path="/qrcodes" element={<ClientQRCodes />} />
                <Route path="/settings" element={<ClientSettings />} />
                <Route path="/new" element={<NewLink />} />
                <Route path="/reset/new-password" element={<NewPassword />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Routes>
    </>
  );
}
export default App;
